<template>
<div class="flex"
     @mouseover="linkIsHovered = true"
     @mouseleave="linkIsHovered = false"
>
  <vx-tooltip ref="copyIconTooltip"
              class="flex items-center"
              :text="isCopied ? 'Browser URL was copied to your clipboard!' : 'Copy Browser URL'"
  >
    <copy-icon v-if="linkIsHovered"
               class="h-4 w-4 text-gray-dark hover:text-primary-focus cursor-pointer"
               :is-copied="isCopied"
               @click.native="copyBrowserUrl()"
    />
    <link-icon v-else class="text-primary h-4 w-4"/>
  </vx-tooltip>
  <vs-tooltip position="top"
              delay="0.2s"
              class="text-primary flex items-center"
  >
    <router-link :key="Math.random()"
                 to=""
                 :href="url"
                 target="_blank"
                 class="ml-1 text-sm hover:underline"
    >
      {{ formatBrowserUrl() }}
    </router-link>
    <template #content>
      <div class="break-all" v-html="url"/>
    </template>
  </vs-tooltip>
</div>
</template>

<script>
import CopyIcon from '@/assets/images/icons/CopyIcon.vue'
import LinkIcon from '@/assets/images/icons/LinkIcon.vue'

export default {
  name: 'CopyableLink',

  components: { CopyIcon, LinkIcon },

  props: {
    url: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      linkIsHovered: false,
      isCopied: false
    }
  },

  methods: {

    formatBrowserUrl() {
      const browserUrl = this.url.replace(/\/$/, '')
      const queryIndex = browserUrl.indexOf('?')
      const protocolPattern = /^(https?:\/\/)?(www\.)?/i
      const cleanedUrl = queryIndex === -1 ?
        browserUrl.replace(protocolPattern, '') :
        browserUrl.slice(0, queryIndex).replace(protocolPattern, '')

      const splitUrl = cleanedUrl.split('/')
      if (splitUrl.length === 1) return this.truncateUrl(splitUrl[0])

      const lastItem = splitUrl[splitUrl.length - 1]
      return '/' + this.truncateUrl(lastItem)
    },

    truncateUrl(url) {
      return url.length > 20 ?
        url.substring(0, 20) + '…' :
        url
    },

    async copyBrowserUrl() {
      this.isCopied = true
      await this.$copyText(this.url)
      this.$refs.copyIconTooltip?.[0]?.mouseenterx()
      await this.sleep(2000)
      this.isCopied = false
      this.$refs.copyIconTooltip?.[0]?.mouseleavex()
    }
  }

}
</script>
